(function () {
    'use strict';

    angular.module("imApp").factory("kpiCompService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3514,
                    parameters: parms || {}
                });
            },
            listWebpages: function (parms) {
                return $ihttp.post({
                    method: 1890,
                    parameters: parms || {}
                });
            },
            listKpiTypes: function (parms) {
                return $ihttp.post({
                    method: 3521,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3515,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
